import React, { memo } from 'react'
import { Typography } from 'antd'
import { isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import { StyledAiHighlightedText } from '../../../common/components/styled'
import { AI_HIGHLIGHT_STYLES } from '../../../common/constants'

import { StyledIngredientExplanationParagraph } from '../styled'

const DishDetailsIngredientReplacements = ({ ingredientReplacements }) => {
  if (isEmpty(ingredientReplacements)) {
    return null
  }

  return (
    <>
      <Typography.Paragraph strong>
        Ingredient replacements
      </Typography.Paragraph>
      {map(ingredientReplacements, ({ replaces, replacement }) => (
        <StyledIngredientExplanationParagraph
          key={`replacementRow-${replaces}-${replacement}`}
        >
          <StyledAiHighlightedText
            highlights={[AI_HIGHLIGHT_STYLES.negativeSynonym.value]}
          >
            {replaces}
          </StyledAiHighlightedText>{' '}
          - {replacement}
        </StyledIngredientExplanationParagraph>
      ))}
    </>
  )
}

DishDetailsIngredientReplacements.propTypes = {
  ingredientReplacements: PropTypes.arrayOf(
    PropTypes.shape({
      replaces: PropTypes.string,
      replacement: PropTypes.string,
    }),
  ).isRequired,
}

export default memo(DishDetailsIngredientReplacements)
